<script setup lang="ts">
import {
  FooterSocials,
  FooterNavigation,
  FooterAppLinks,
  FooterServices,
} from "@/modules/app-footer";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <footer class="app-footer">
    <div class="app-footer__top container">
      <FooterNavigation />

      <FooterServices />
    </div>
    <div class="app-footer__middle">
      <div class="container">
        <p>
          {{ t("footer.copyright") }}
        </p>

        <FooterAppLinks />
      </div>
    </div>
    <div class="app-footer__bottom container">
      <img src="../../assets/images/payments.svg" alt="" />

      <FooterSocials />
    </div>
  </footer>
</template>

<style scoped lang="scss">
.app-footer {
  background: var(--color-semantic-background-normal-contrast);

  &__top {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: calc($base-space * 16);
    padding: calc($base-space * 6) 0;
  }

  &__middle {
    padding: calc($base-space * 6) 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    > .container {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr auto;
      gap: calc($base-space * 16);
    }

    p {
      @include caption();
      color: var(--color-semantic-content-normal-tertiary);
    }
  }

  &__bottom {
    padding: calc($base-space * 4) 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
